import { Reveal } from "../Reveal";
import { BookButton } from "../Cta";

export const WalkWithMe = () => (
  <section id="walk-with-me" className="bg-night text-paper" data-testid="walk-with-me-section">
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-20 md:py-28">
      <Reveal>
        <p
          className="text-xs md:text-sm tracking-[0.25em] uppercase font-semibold text-paper/50"
          data-testid="walk-with-me-eyebrow"
        >
          Ongoing support
        </p>
        <h2 className="mt-4 font-serif text-3xl md:text-5xl tracking-tight leading-[1.1]">
          Walk With Me.
        </h2>
        <p className="mt-8 font-serif text-4xl md:text-5xl tracking-tighter" data-testid="walk-with-me-price">
          £495
          <span className="text-lg md:text-xl text-paper/50 tracking-normal"> / month</span>
        </p>
        <p className="mt-8 max-w-xl text-lg md:text-xl leading-relaxed text-paper/85">
          A calm person in your corner when the situation isn’t calm.
        </p>
        <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-paper/70">
          Four 45–60 minute calls each month, plus defined WhatsApp and
          voice-note access between sessions.
        </p>
        <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-paper/70" data-testid="walk-with-me-value-line">
          Sometimes the value is having somewhere to take the thought before
          you turn it into an action.
        </p>
        <div className="mt-10">
          <BookButton label="Start with a First Walk" testid="walk-with-me-cta" dark />
        </div>
        <p className="mt-6 text-sm text-paper/50">
          If ongoing support feels useful after that first conversation, we
          can continue from there.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-paper/40" data-testid="walk-with-me-availability-note">
          Between-session messages aren’t instant — Luke replies when
          reasonably possible during normal weekday hours. This isn’t an
          emergency service.
        </p>
      </Reveal>
    </div>
  </section>
);
